<div class="order-summary">
  <div *ngIf="isLoading" class="wb-loader">
    <span class="loading-animation"></span>
  </div>
  <form *ngIf="isLoaded" novalidate [formGroup]="orderSummaryFormGroup">
    <div class="row text-center wb-summary-title">
      <h1>{{header}}</h1>
    </div>
    <app-banner-nudge [@fade]="isNudgeBanner ? 'shown' : 'hidden'" *ngIf='isNudgeBanner' (onCloseNudge) = 'hideNudgeBanner()' [bannerMessageText] ='bannerMessageText' [bannerTextColorHex] ='bannerTextColorHex' [bannerColorHex]='bannerColorHex'></app-banner-nudge>
    <div class="inner-container" [ngClass] = "isNudgeBanner ? 'nudge-banner':''">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center wab-bdr-btm">
          <h2>Order Total: ${{orderTotal | number : '1.2-2'}}</h2>
        </div>
      </div>
      <div class="row" *ngIf="showAddFavorite">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center" *ngIf="orderSummaryFormGroup.valid">
          <b class="favorite-question wab-bdr-tp-btm wab-bdr-none">
            <span *ngIf="!isFavorite">Would you like to favorite this order?</span>
            <span *ngIf="isFavorite">{{favName}}</span>
            <i *ngIf="isFavorite" class="fa fa-heart pull-right not-clickable" aria-hidden="true"></i>
            <i *ngIf="!isFavorite && showAddFavorite" class="fa fa-heart-o pull-right" aria-hidden="true" (click)="saveFavConfirmation()"></i>
          </b>
        </div>
      </div>
      <!-- Handling Redeem Reward option availability based on user selection and Redux state -->
      <div class="row" *ngIf=" currentRewards && (orderdCollection && !orderdCollection.isRewardAdded) && !isOfferInCart">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <a class="reward-reedem wab-bdr-tp-btm" (click)="goToRewardsLanding()">
            <i class="fa fa-trophy" aria-hidden="true"></i>
            Redeem Reward
          </a>
        </div>
      </div>
      <!-- This is a list of DIV -->

      <div *ngFor="let orderItem of orderdCollection.childRecipes; let i = index" class="order-wrapper" [ngClass]="{'lto-bg':orderItem.isRecipeNotAvailable }">
        <div class="icon-and-header">
          <div class="row">
            <div class="pull-right clear" (click)="clearItems(this.orderItem.orderItemId)">
              <svg xmlns="http://www.w3.org/2000/svg" class="bi bi-x" viewBox="2 2 16 16"> <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/> </svg>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center lft-side">
              <div class="media-img">
                <!-- TODO: use friendly name for below -->
                <img class="img-responsive" [src]="menuImageUrlPrefix + '/' + (orderItem.webImageUrl ?? orderItem.imageUrl ?? '')" alt="{{ getRecipeName(orderItem?orderItem.name:'',orderItem?orderItem.subTitle:'')}}" />
              </div>
              <div class="rgt-side">
                <b class="edit-text" *ngIf="Ismutiitems && !isLimitedTimeOfferExpired && !orderItem.isRecipeNotAvailable">
                  <label for="custname{{i}}">Who is this for?</label>
                  <input aria-label="Who is this for?" type="text" class="form-control" id="custname" name="custname{{i}}" (blur)="updateCustomerName(orderItem.orderItemId,orderItem.customName)"
                    formControlName="custname{{i}}" [(ngModel)]="orderItem.customName" [maxlength]="25" />
                  <app-validation-message [control]="getControlName(i, orderSummaryFormGroup.controls)" class="form-error"></app-validation-message>
                </b>
                <div class="wab-cat-detail">
                  <h4>{{ getRecipeName(orderItem?orderItem.name:'',orderItem?orderItem.subTitle:'')}} </h4>
                  <p *ngIf="!isLimitedTimeOfferExpired">{{ getRecipeSubtitle(orderItem?orderItem.name:'',orderItem?orderItem.subTitle:'')}}</p>
                </div>
                <div class="text-right wab-cal-detail" *ngIf="!isLimitedTimeOfferExpired && !orderItem.isRecipeNotAvailable">
                  <h4>
                    <!--rewards and gift icons-->
                    <i class="fa fa-gift" aria-hidden="true" *ngIf="isOfferItem(orderItem)"></i>
                    <i class="fa fa-trophy" aria-hidden="true" *ngIf="isRewardItem(orderItem)"></i>
                    ${{orderItem?.totalPrice | number: '1.2-2'}}
                  </h4>
                  <h4 class="cal-detail">{{orderItem?.totalCalories}} Cal
                  </h4>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.isRecipeNotAvailable">
                  <hr/>
                  <span *ngIf="!orderItem?.isRecipeNonExistent">
                    This menu item is not available at this location. Please select a different location.
                  </span>
                  <span *ngIf="orderItem?.isRecipeNonExistent">
                    This menu item is no longer available. Please remove this item from your order to continue.
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.isDrinksNotAvailable">
                  <hr/>
                  <span>
                    {{drinksNotAvailable(false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.nonExistentModifierGroups?.length">
                  <hr/>
                  <span>
                    {{modifierGroupDoesNotexist(orderItem, false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.nonExistentModifiers?.length">
                  <hr/>
                  <span>
                    {{modifiersDoNotExist(orderItem, false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.modifierGroupsWithServeRestrictions?.length">
                  <hr/>
                  <span>
                    {{modifierGroupsNotServedAtThisTime(orderItem, false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.unAvailableModifiers?.length">
                  <hr/>
                  <span>
                    {{modifiersNotAvailable(orderItem, false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.nonExistentSpecialInstructions?.length">
                  <hr/>
                  <span>
                    {{modifierSpecialInstructionsDoNotExist(orderItem, false)}}
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="orderItem?.recipeNotAvailableInTimeStampErrorMessage">
                  <div>
                    <hr/>
                    <span>
                      {{orderItem.recipeNotAvailableInTimeStampErrorMessage}}
                    </span>
                    <hr/>
                  </div>
                </div>
                <div class="breakfast-hint" *ngIf="isLimitedTimeOfferExpired">
                  <hr/>
                  <span>
                    This Limited Time Offer is no longer available as of {{today | date:'M/d/yyyy'}}.
                  </span>
                  <hr/>
                </div>
                <div class="breakfast-hint" *ngIf="isLimitedTimeOfferAvailable">
                  <hr/>
                  <span>
                    This Limited Time Offer is available till {{orderItem.availability.expiry | date:'M/d/yyyy'}}.
                  </span>
                  <hr/>
                </div>
                <strong *ngIf="isLimitedTimeOfferExpired || orderItem.isRecipeNotAvailable" (click)="removeLimitedOfferItem(orderItem)">Got it, remove from order.</strong>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="!isLimitedTimeOfferExpired && !orderItem.isRecipeNotAvailable">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <a *ngIf="orderItem?.mealIncludes !== '' || orderItem?.whatsOnIt !== '' " class="show-details" [ngClass]="{'collapsed': !accToggle[i]?.openStatus}">
                  <span class="dt-open" *ngIf="!accToggle[i]?.openStatus" (click)="checkacctoggle(i,true)">Details</span>
                  <span class="dt-close" *ngIf="accToggle[i]?.openStatus" (click)="checkacctoggle(i, false)">Details</span>
                </a>
                <div id="{{i}}" class="includes-sides-customization" *ngIf="accToggle[i]?.openStatus">
                  <b>Includes:
                    <span>{{orderItem.whatsOnIt}}</span>
                  </b>
                  <b *ngIf="menuUtil.hasSideAndDrink(orderItem)">Side & Drinks:
                    <span>{{orderItem.mealIncludes}}</span>
                  </b>
                </div>
            </div>
          </div>
        </div>

        <div class="row editRow" *ngIf="!isLimitedTimeOfferExpired && !orderItem.isRecipeNotAvailable">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
              <b class="edit-text pull-left" *ngIf="!orderItem?.isRecipeNotAvailable" (click)="goToCustomization(orderItem)">Edit Item</b>
              <div class="pull-right">
                <app-wb-selector tabindex="0" [labels]="getDisplayList()" [selectorType]="'stepper'" [valueFromOrderSummary]="true" [inputId]="orderItem?.orderItemId"
                  [value]="orderItem?.quantity" (typeEvent)="calculateTotalPrice($event, orderItem.totalPrice)" [pageName]="'orderSummary'"
                  [isReward]="isRewardItem(orderItem)"></app-wb-selector>
            </div>
          </div>
        </div>
        <!-- Doesn't put horizontal line under last item -->
        <hr *ngIf="i !== orderdCollection.childRecipes.length - 1">

      </div>

      <div class="totals-taxes-wrapper row">
        <hr/>
        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9 text-right">
          <p *ngIf="!isTaxIncluded">Subtotal</p>
          <p *ngIf="orderSummaryItems?.deliveryFee !== null">Delivery Fee</p>
          <p *ngIf="orderSummaryItems?.serviceFee !== null">Service Fee</p>
          <p *ngIf="orderSummaryItems?.tip !== null && orderSummaryItems?.tip !== undefined">Tip</p>
          <p *ngIf="!isTaxIncluded">Tax*</p>
          <p *ngFor="let fee of orderSummaryItems?.namedFees">{{fee?.name}}</p>
          <p class="total">Total</p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-right">
            <p *ngIf="!isTaxIncluded">${{subTotal | number: '1.2-2'}}</p>
            <p *ngIf="orderSummaryItems?.deliveryFee !== null">${{orderSummaryItems?.deliveryFee | number: '1.2-2'}}</p>
            <p *ngIf="orderSummaryItems?.serviceFee !== null">${{orderSummaryItems?.serviceFee | number: '1.2-2'}}</p>
            <p *ngIf="orderSummaryItems?.tip !== null && orderSummaryItems?.tip !== undefined">${{orderSummaryItems?.tip | number: '1.2-2'}}</p>
            <p *ngIf="!isTaxIncluded">${{tax | number: '1.2-2'}}</p>
            <p *ngFor="let fee of orderSummaryItems?.namedFees">${{fee?.fee | number: '1.2-2'}}</p>
            <p class="total">${{orderTotal | number: '1.2-2'}}</p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
          <span *ngIf="!isTaxIncluded">*Tax is approximate until sale is finalized</span>
          <span *ngIf="isTaxIncluded">Tax Included In Total</span>
        </div>
      </div>


      <hr>

      <div class="pickup-loc-wrapper">
        <b>{{orderdCollection?.automaticDeliveryLocation ? 'Delivery Location' :'Pickup Location'}}</b>
        <div class="row mg-top-20">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center lft-side">
            <div class="media-img">
              <img class="img-responsive" src="{{locationImageUrlPrefix}}location_icon.png" alt="location icon" />
            </div>
            <div class="rgt-side">
              <div class="wab-cat-detail text-left">
                <b>{{orderdCollection?.automaticDeliveryLocation ? orderdCollection.deliveryAddress?.line1 : locationsEntity?.locationName}} </b>
                <b>{{orderdCollection?.automaticDeliveryLocation ? orderdCollection.deliveryAddress?.line2 : locationsEntity?.address1}}</b>
                <p>{{orderdCollection?.automaticDeliveryLocation ? orderdCollection.deliveryAddress?.city: locationsEntity?.city + ', ' + locationsEntity?.state + ', ' + locationsEntity?.zip}}</p>
                <p>{{orderdCollection?.automaticDeliveryLocation ?
                   (orderdCollection.deliveryAddress?.state + ' '+ orderdCollection.deliveryAddress?.zipCode) : locationsEntity?.address2}}</p>
                <b *ngIf="!orderdCollection?.automaticDeliveryLocation" [ngClass]="[(locationsEntity?.openStatus == 'Closed') ? 'text-red' : 'text-green']">{{locationsEntity?.openCloseDisplayStatus}}</b>
              </div>
              <div class="text-right wab-cal-detail">
                <p class="favorite-question" (click)="changeLocation()">Change</p>
              </div>
            </div>
          </div>
          <div class="mg-top-10 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
            <p class="hint-text">2,000 Calories a day is used for general nutrition advice, but calorie needs vary.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row btn-background">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
        <button class="btn wb-btn-default" (click)="goToMenuLanding()">Order More</button>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
        <button class="btn wb-btn-default" (click)="CheckoutSubmit()" [disabled]="!orderSummaryFormGroup.valid">
          Checkout
          <div *ngIf="checkOutLoading" class="wb-loader">
            <span class="loading-animation"></span>
          </div>
        </button>
      </div>
    </div>
  </form>
</div>
